import types from 'constants/CheckinConstants';
import axios from 'axios';
import qs from 'qs';
import {getURL} from '../routes';

export function fetchCheckinInfoAPI() {
  return axios.get(getURL('/api/checkin'))
}

export function checkinAPI(date, sid, checkout=false, lat=null, lng=null) {
  return axios.post(getURL('/api/checkin'),
                qs.stringify({
                  'date': date,
                  'shift': sid,
                  'lat': lat,
                  'lng': lng,
                  'checkout': checkout
                }))
}

export function checkinfailtologAPI(msg) {
  return axios.post(getURL('/api/checkin'),
                qs.stringify({
                  'error_log': msg
                }))
}

export function fetchCheckinInfo() {
  return dispatch => {
    fetchCheckinInfoAPI()
      .then((respone) => {
          let {current, upcoming} = respone.data;
          dispatch(refreshCheckinInfo(current, upcoming));
        })
      .catch((error) => {
        alert(error)
      })
  }
}

export function tryCheckin(date, sid, fn, checkout=false) {
  return dispatch => {
    //trying to get location
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            try{
              let lat = pos.coords.latitude;
              let lng = pos.coords.longitude;
              fn();
              checkinAPI(date, sid, checkout, lat, lng)
                .then((respone) => {
                  let {checkinAt} = respone.data;
                  dispatch(updateRecordAttr((checkout? 'checkoutAt': 'checkinAt'), sid, checkinAt));
                })
                .catch(() => {
                  alert("簽到失敗");
                  location.reload();
                })            
            } catch (err) {
              fn();
              checkinfailtologAPI(err.message)
                .then(() => {
                  fn();
                  alert("定位失敗");
                })
                .catch(() => {
                  fn();
                  alert("定位失敗");
                })
              fn();
            } 
          },
          (err) => {
            fn();
            checkinfailtologAPI(err.message)
              .then(() => {
                fn();
                alert("定位失敗");
              })
              .catch(() => {
                fn();
                alert("定位失敗");
              })
            fn();
          }
        );
      }else {
        fn();
        checkinfailtologAPI("geolocation not found in navigator")
          .then(() => {
            fn();
            alert("定位失敗");
          })
          .catch(() => {
            fn();
            alert("定位失敗");
          })
        fn();
      }
  }
}

export function refreshCheckinInfo(current, upcoming) {
  return {
    type: types.REFRESH_CHECKIN_RECORD,
    current, upcoming
  }
}

export function updateRecordAttr(attr, sid, value) {
  return {
    type: types.UPDATE_RECORD_ATTR,
    attr, sid, value
  }
}



// WEBPACK FOOTER //
// ./src/actions/CheckinActions.js